"use client";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postContactUs } from "@/redux/Slice/contactUs/ContactUsSlice";
import { Check, Loader } from "lucide-react";
import Link from "next/link";
import Image from "next/image";
import { toast } from "sonner";

const ContactUs = () => {
  const dispatch = useDispatch();
  const { data, error, status } = useSelector((state) => state.contact);

  const [errorMessage, setErrorMessage] = useState({
    email: "",
    name: "",
    message: "",
  });

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    message: "",
  });
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleValidation = () => {
    let isValid = true;
    if (!formData.name) {
      setErrorMessage((prev) => ({
        ...prev,
        name: "Name is required",
      }));
      isValid = false;
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) {
      setErrorMessage((prev) => ({
        ...prev,
        email: "Please enter a valid email address",
      }));
      isValid = false;
    }
    if (!formData.message) {
      setErrorMessage((prev) => ({
        ...prev,
        message: "Message is required",
      }));
      isValid = false;
    }
    return isValid;
  };

  const glassToastSuccess = {
    style: {
      background: "rgba(34, 120, 70, 0.78)",

      border: "1px solid rgba(120, 255, 180, 0.22)",

      backdropFilter: "blur(18px)",
      WebkitBackdropFilter: "blur(18px)",

      boxShadow: `
      0 8px 24px rgba(20, 90, 50, 0.14),
      inset 0 1px 0 rgba(255,255,255,0.14)
    `,

      borderRadius: "18px",

      color: "#fff",
      fontWeight: 500,
    },
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!handleValidation()) return;

    try {
      const result = await dispatch(postContactUs(formData)).unwrap();

      toast.success(result?.message || "Message sent successfully!", {
        duration: 2000,
        position: "top-right",
        ...glassToastSuccess,
      });

      setFormData({
        name: "",
        email: "",
        phone_number: "",
        message: "",
      });
    } catch (error) {
      toast.error(error?.message || "Failed to send message.", {
        duration: 2000,
        position: "top-right",
      });
    }
  };

  useEffect(() => {
    if (formData.name || formData.email || formData.message) {
      setErrorMessage({
        name: "",
        email: "",
        message: "",
      });
    }
  }, [formData, setFormData]);

  console.log("contact us data ", data, "error ", error, "status ", status);

  return (
    <main className="flex justify-center  w-full min-h-96 px-0 xl:px-10 pb-5">
      <section className="flex flex-col lg:flex-row max-w-8xl w-full  rounded-xl overflow-hidden">
        {/* Left Side */}
        <div className="left w-full lg:w-1/2 p-5 sm:p-10 ">
          <h1 className=" text-lg font-bold mb-4 text-[#3232A4] tracking-wide">
            CONTACT US
          </h1>
          <h2 className=" text-4xl md:text-6xl font-semibold mb-2 text-gray-800">
            Need a hand?
          </h2>
          <h3 className="text-2xl md:text-4xl mb-4 font-bold text-[#3232A4]">
            We're here to help!
          </h3>
          <p className="text-sm md:text-lg  text-gray-600 font-ember font-medium">
            Fill out the contact form, and our team of experts will respond to
            any questions or inquiries you may have.
          </p>

          {/* Extra Contact Info */}
          <div className="relative hidden w-full mt-10 h-2/3 text-gray-700 lg:block">
            <Image
              src="/assets/images/contact/contact.png"
              alt="Contact Us"
              fill
              className="object-contain bg-blend-multiply"
              priority
            />
          </div>
        </div>

        {/* Right Form */}
        <div className="right-form w-full lg:w-1/2 p-5 sm:p-10 ">
          <p className="mb-3 text-sm text-gray-500">
            Send us a note in the contact form below. (*) Indicates required
            fields.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col gap-5">
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Name <span className="text-red-500">*</span>
              </label>

              <input
                type="text"
                placeholder="Enter your name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full rounded-lg border border-[#3232AA]/40  py-2 pl-4 pr-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-[#3232AA]/50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#3232AA]/10"
              />
              {errorMessage.name && (
                <p className="text-red-500 text-xs">{errorMessage.name}</p>
              )}
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email <span className="text-red-500">*</span>
              </label>

              <input
                type="email"
                placeholder="Enter your email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full rounded-lg border border-[#3232AA]/40 py-2 pl-4 pr-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-[#3232AA]/50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#3232AA]/10"
              />
              {errorMessage.email && (
                <p className="text-red-500 text-xs">{errorMessage.email}</p>
              )}
            </div>
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Phone Number <span className="text-gray-400">(Optional)</span>
              </label>

              <input
                type="tel"
                name="phone_number"
                value={formData.phone_number ?? ""}
                onChange={handleChange}
                placeholder="Phone Number"
                className="w-full rounded-lg border border-[#3232AA]/40 py-2 pl-4 pr-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-[#3232AA]/50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#3232AA]/10"
              />
            </div>

            <div>
              <label
                htmlFor="message"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Message <span className="text-red-500">*</span>
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Enter your message here..."
                rows="4"
                className="w-full rounded-lg border border-[#3232AA]/40 py-2 pl-4 pr-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-[#3232AA]/50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#3232AA]/10"
              ></textarea>
              {errorMessage.message && (
                <p className="text-red-500 text-xs">{errorMessage.message}</p>
              )}
            </div>

            <div className="space-y-4">
              <div className="flex items-start  gap-3">
                <input
                  type="checkbox"
                  className="w-4 mt-1.5 accent-[#3232A4] cursor-pointer "
                />
                <p className="text-sm text-gray-500 leading-relaxed">
                  I allow Imagive to use my contact data and keep me informed of
                  services and offerings by email.
                </p>
              </div>

              <div className="flex items-start gap-3">
                <input
                  type="checkbox"
                  className="w-4 mt-1.5 accent-[#3232A4] cursor-pointer"
                />
                <p className="text-sm text-gray-500 leading-relaxed">
                  I also allow to be contacted by phone.
                </p>
              </div>

              <div className="flex items-start gap-3">
                <p className="text-sm text-gray-500 leading-relaxed">
                  By submitting this, you acknowledge you have read and
                  understood the{" "}
                  <Link
                    href="/privacy-policy"
                    className="text-[#3232A4] font-medium cursor-pointer hover:underline"
                  >
                    Imagive Privacy Statement
                  </Link>
                  .
                </p>
              </div>
            </div>

            {status === "idle" || status === "loading" ? (
              <button
                type="submit"
                disabled={status === "loading"}
                className="btn-gradient"
              >
                {status === "loading" ? (
                  <div className="flex items-center justify-center gap-2">
                    Sending... <Loader className="animate-spin" size={16} />
                  </div>
                ) : status === "succeeded" ? (
                  <div className="flex items-center justify-center gap-2">
                    <Check strokeWidth={1.25} size={16} /> We have received your
                    query
                  </div>
                ) : (
                  "Send Messages"
                )}
              </button>
            ) : (
              <div
                className={`flex items-center gap-2 text-sm font-medium ${
                  status === "succeeded" ? "text-green-600" : "text-red-600"
                }`}
              >
                {status === "succeeded" ? (
                  <>
                    <Check strokeWidth={1.25} size={16} /> We have received your
                    query
                  </>
                ) : (
                  <>
                    <span className="font-bold">Error:</span> {data?.message}
                  </>
                )}
              </div>
            )}
          </form>
        </div>
      </section>
    </main>
  );
};

export default ContactUs;
